import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, X } from 'lucide-react';

const KEY = 'pfl_banner_closed';

export default function ChallengeBanner() {
  const [closed, setClosed] = useState(() => sessionStorage.getItem(KEY) === '1');
  if (closed) return null;
  const close = () => { sessionStorage.setItem(KEY, '1'); setClosed(true); };
  return (
    <div className="relative w-full bg-[#0A0F1C] text-white" data-testid="challenge-banner">
      <div className="flex h-1 w-full" aria-hidden="true">
        <span className="flex-1 bg-[#16A34A]" /><span className="flex-1 bg-[#1D4ED8]" /><span className="flex-1 bg-[#F97316]" />
      </div>
      <Link
        to="/challenge"
        className="group flex w-full flex-wrap items-center justify-center gap-x-4 gap-y-2 px-12 py-3 text-center sm:py-3.5"
        data-testid="challenge-banner-link"
      >
        <span className="text-sm font-bold leading-snug sm:text-base md:text-lg">
          Join the{' '}
          <span className="whitespace-nowrap font-extrabold">
            <span className="text-[#F97316]">Purpose</span> <span className="text-[#60A5FA]">Fit</span> <span className="text-[#22C55E]">Life</span>
          </span>{' '}
          90-Day Health &amp; Consistency Challenge
        </span>
        <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-[#F97316] px-4 py-1.5 text-xs font-bold uppercase tracking-wide transition-transform duration-200 group-hover:translate-x-1 sm:text-sm" data-testid="challenge-banner-cta">
          Join the challenge <ArrowRight size={14} />
        </span>
      </Link>
      <button
        type="button"
        onClick={close}
        aria-label="Close challenge banner"
        className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full p-2 text-white/70 transition-colors hover:bg-white/10 hover:text-white sm:right-4"
        data-testid="challenge-banner-close"
      >
        <X size={18} />
      </button>
    </div>
  );
}
